// Konstruktor notifikátorů definující strukturu, vlastnosti metody a zajišťující fallback u neimplementovaných funkcí custom. notifikátoru
EBContext.modules.Notificator = function (options) {
	var self = this;
	this.options = {
		defaults: {
			timeout: 2000,
			progressBar: {
				show: true,
				location: 'top',
				onProgress: null,
				onFinish: function (notification) {
					notification.dismiss();
				}
			},
			closeBtn: false,
			closeOnClick: true,
			location: 'top-right'
		},
		messageTypes: {
			info: {
				elClass: 'alert-info'
			},
			success: {
				elClass: 'alert-success'
			},
			warning: {
				elClass: 'alert-warning'
			},
			error: {
				elClass: 'alert-danger'
			},
			process: {
				elClass: 'alert-light'
			}
		},
		// Řeší zkonstruování elementu, jeho vložení do DOM stromu a bind eventů
		generate: function (notification) {
			var notificationEl = EBContext.utils.template();
		},
		// Pouze zobrazuje skrytou notifikaci
		show: function (notification) {

		},
		// Pouze skrývá DOM element notifikace
		hide: function (notification) {

		},
		// Řeší pouze odstranění DOM elementu
		dismiss: function (notification) {

		},
		// Řeší pouze styly DOM elementu
		remind: function (notification) {

		},
		// Obsluhuje pouze zobrazení progressbaru
		progress: function (notification, min, max, increment) {

		},
		// Obsluhuje pouze skládání v rámci DOM elementů
		fold: function (notification) {

		}
	};
	this.notifications = {};

	this.init = function (options) {
		EBContext.utils.extendObj(false, self.options, options);
		this.clear();
	};

	this.new = function (message, type, options) {
		var id = 'notify_' + Object.keys(self.notifications).length;
		self.notifications[id] = new notification(message, type, EBContext.utils.extendObj(false, self.options.defaults, options));
	};

	this.clear = function () {
		var i;
		var nk = Object.keys(self.notifications);
		for (i=0;i<nk.length;i++) {
			self.notifications[nk[i]].dismiss();
		}
	};

	var notification = function (message, type, options) {
		var nf = this;
		this.options = options;

		this.parent = null;
		this.children = [];

		// Zobrazí notifikaci
		this.show = this.options.show;

		// Odstraní notifikaci
		this.dismiss = this.options.dismiss;

		// Vizuální zvýraznění (shake, bounce, pulse, ...)
		this.remind = this.options.remind;

		// V případě např. stahování nebo odesílání dat může notifikace zobrazovat progress-bar
		this.progress = function (min, max, progress) {
			this.options.progress(this, min, max, progress);
		};

		// V případě, že má notifikace nějaké podřízené, tak je složí (např. je skryje, a zobrazí jejich počet nebo počty jednotlivých typů, a tlačítko pro rozbalení)
		this.fold = this.options.fold;

		// Při zavolání konstruktoru rovnou zobrazit - asi není žádný důvod, proč by se s tím mělo čekat
		this.show();

		//vrátí referenci na nově založený objekt
		return this;
	};

	this.init(options);
	return this;
};

// objekt výchozího notifikátoru - umístěno v rootu EBContextu pro snadný přístup ke všem metodám
EBContext.notificator = new EBContext.modules.Notificator();

// Založení nové notifikace výchozího notifikátoru - umístěno v rootu EBContextu pro snadný přístup
EBContext.notify = EBContext.notificator.new;


/* Příklady použití:
EBContext.notify('Byli jste odhlášeni!', 'info');
EBContext.notify('Položka nebyla přidána do košíku - Neplatné množství!', 'error', {closeOnClick: true, location: document.getEleemntById('basketBox')});

var progressNotify = EBContext.notify('Stahuje se soubor "virus.zip"', 'info');
xhr.addEventListener('progress', function(){
	progressNotify.progress(0, ...)
});

*/

// EBContext.notify = function (message, type, options) {
// 	$.notify(message, EBContext.utils.extendObj(false, {
// 		className: type
// 	}, options));
// };